import * as Yup from 'yup';
import i18nInstance from '../../../config/i18n';

export const loginSchema = Yup.object().shape({
  password: Yup.string().required(() => i18nInstance.t('validation:required')),
  username: Yup.string()
    .email(() => i18nInstance.t('validation:string.email'))
    .required(() => i18nInstance.t('validation:required')),
});
